import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  copyButton: {
    padding: theme.spacing(1, 2, 1, 2),
    borderRadius: 3,
    ...reskinStyles(theme, { borderRadius: 22 }),
    verticalAlign: 'middle'
  }
}));

export default useStyles;
